import { getAppErrorDetails } from 'utils/AppError';

/**
 * GraphQL error codes the HRIS/BFF returns that are client-safe (the message may
 * be shown to the user). Mirrors the cross-repo error-code contract.
 */
export const CLIENT_SAFE_GRAPHQL_CODES = [
  'FIELD_VALIDATION_FAILED',
  'CONFLICT',
  'FORBIDDEN',
  'NOT_FOUND',
] as const;

/**
 * Extract the GraphQL error code from a thrown error. graphQLApi maps
 * `response.extensions.code` onto AppError.code (see utils/Api.ts).
 */
export const getGraphqlErrorCode = (error: unknown): string | undefined => {
  if (!error) return undefined;
  return getAppErrorDetails(error).code || undefined;
};

export const isForbiddenError = (error: unknown): boolean =>
  getGraphqlErrorCode(error) === 'FORBIDDEN';

/**
 * The client-safe message from a GraphQL error, if the code is one the contract
 * marks as user-showable; otherwise undefined so callers fall back to generic copy.
 */
export const getClientSafeMessage = (error: unknown): string | undefined => {
  const code = getGraphqlErrorCode(error);
  if (!code || !CLIENT_SAFE_GRAPHQL_CODES.includes(code as never)) return undefined;
  const message = getAppErrorDetails(error).messageForUser;
  return message && message.trim() ? message : undefined;
};
